import { Icon } from "@pepperstone/pepper-ui-kit";
import { useTranslation } from "react-i18next";
import { BankTransferDetail } from "./BankTransferDetail";
import styles from "./BankTransferDetail.module.css";
import { CopyToClipboard } from "@/components/copy-to-clipboard/CopyToClipboard";

type BankTransferDetailListProps = {
  items: Record<string, string>;
};

export const BankTransferDetailList = ({
  items,
}: BankTransferDetailListProps) => {
  const { t } = useTranslation();

  // Translation keys used dynamically - ensure i18next-parser detects them
  // t('deposit.payment_placement.bank_transfer.account_name')
  // t('deposit.payment_placement.bank_transfer.bank_name')
  // t('deposit.payment_placement.bank_transfer.bank_address')
  // t('deposit.payment_placement.bank_transfer.swift_code')
  // t('deposit.payment_placement.bank_transfer.sort_code')
  // t('deposit.payment_placement.bank_transfer.reference_code')
  // t('deposit.payment_placement.bank_transfer.account_number')
  // t('deposit.payment_placement.bank_transfer.iban')
  // t('deposit.payment_placement.bank_transfer.currency')
  // t('deposit.payment_placement.bank_transfer.amount')
  // t('deposit.payment_placement.bank_transfer.estimated_arrival')

  return (
    <div className={styles.DetailsContainer}>
      {Object.entries(items).map(([key, value], i) =>
        key === "reference_code" ? (
          <div key={i}>
            <BankTransferDetail
              title={t(`deposit.payment_placement.bank_transfer.${key}`)}
              value={value}
            >
              <CopyToClipboard
                text={value}
                label={t(`deposit.payment_placement.bank_transfer.${key}`)}
              />
            </BankTransferDetail>
            <div className={styles.ReferenceNote}>
              <Icon icon="alert-circle" />
              {t("deposit.payment_placement.bank_transfer.reference_code_note")}
            </div>
          </div>
        ) : (
          <BankTransferDetail
            key={i}
            title={t(`deposit.payment_placement.bank_transfer.${key}`)}
            value={value}
          >
            <CopyToClipboard
              text={value}
              label={t(`deposit.payment_placement.bank_transfer.${key}`)}
            />
          </BankTransferDetail>
        )
      )}
    </div>
  );
};
